import React from 'react';
import { IconProps } from './model/IconInterface';

const ShipIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor', fill }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? color : 'none'}
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M4 17l-1.2-4.5L12 9.5l9.2 3L20 17" /><path d="M12 9.5V4h-2" /><path d="M2 20c1 1 2.5 1 3.5 0s2.5-1 3.5 0 2.5 1 3.5 0 2.5-1 3.5 0 2.5 1 3.5 0" />
    </svg>
  );
};

export default ShipIcon;
